<template>
  <div
    v-cloak
    class="file-upload-area"
    @drop.prevent="dropFile"
    @dragover.prevent
  >
  <label :for="`upload-file${name}`">
    {{ inputLabel }}
    </label>
    <input
      type="file"
      :id="`upload-file${name}`"
      :key="`uploadFile${key}`"
      name="file"
      class="upload-file hidden"
      :accept="accept"
      ref="file"
      @change="selectFile"
    />
    <ul v-if="files.length">
      <li v-for="(file, i) in files" :key="`fileList${i}${key}`">
        {{ file.name }} ({{ file.size }} kb)
        <i
          role="button"
          v-tooltip="$t('form.button.remove')"
          class="remove-item fas fa-minus-circle has-tooltip"
          @click="removeFile(file)"
        ></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FileUpload",

  props: {
    max: {
      type: Number,
      required: false,
      default: 1,
    },
    name: {
      type: String
    },
    accept: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
  },

  data: function () {
    return {
      inputFile: null,
      files: [],
      key: 0,
    };
  },

  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    },
    inputLabel() {
      if (this.label) return this.label;

      return this.$tc("uploader.select_files", this.max);
    },
  },

  methods: {
    selectFile() {
      this.addFiles(this.$refs.file.files);
    },
    dropFile(e) {
      this.addFiles(e.dataTransfer.files);
    },
    addFiles(newFiles) {
      if (!newFiles) return;

      Array.from(newFiles).forEach((file) => {
        this.files.push(file);
      });

      this.removeExtrarFiles();

      this.key++;
      this.update();
    },
    removeExtrarFiles() {
      const toRemove = this.files.length - this.max;

      if (toRemove <= 0) return;

      this.files.splice(0, toRemove);
    },
    removeFile(file) {
      this.files = this.files.filter((item) => {
        return item != file;
      });
      this.update();
    },
    update() {
      let formData = new FormData();

      if (this.max === 1) {
        formData.append("file", this.files[0]);
      } else {
        this.files.forEach((f, x) => {
          formData.append("file" + (x + 1), f);
        });
      }

      this.$emit("onChange", formData);
    },
  },
};
</script>

<style lang="scss">
.file-upload-area {
  margin-top: 20px;
  background: #f7f7f7;
  border: 2px dashed #e3e3e3;
  border-radius: 5px;
  display: inline-block;
  cursor: pointer;
  min-width: 300px;
  transition: all 0.3s;

  &:hover {
    background: #f0f0f0;
    border: 2px dashed #cecece;
    transition: all 0.3s;
  }

  label {
    padding: 10px 20px;
    cursor: pointer;
    text-align: center;
  }

  ul {
    margin-top: 10px;
    padding: 0 20px 20px 20px;
    text-align: center;
  }

  .upload-file {
    padding: 20px 20px;
    margin: 20px;
    min-width: 300px;
  }
}
</style>
